import rootSaga from './_redux/sagas';
import { changeLanguage, getCompanyNews } from './_redux/actions';
import reducer from './_redux/reducer';

const changeLanguageRequest = changeLanguage.request;

export { rootSaga, reducer, changeLanguageRequest as changeLanguage, getCompanyNews };
